// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import ITidiedUp from "assets/i-tidied-up";

const ModalResult = ({
  onClose,
  isOpen,
  description,
  title,
  onConfirm,
  rightBtnText,
  leftBtnText,
  leftBtnAction,
  rightBtnIcon,
  disabled,
  image,
  ...props
}) => {
  return (
    <Modal isOpen={isOpen} onClose={!disabled ? onClose : undefined} {...props}>
      <div
        className="w-[360px] flex flex-col justify-end z-[42] bg-white rounded-[16px]"
      >
        <div className="px-4 py-2 flex items-center justify-center flex-col">
          {image && <img src={image} alt="modal-confirm" className="w-[160px] aspect-square mx-auto" />}
          <p className="text-[17px] font-inter-semibold leading-[28px] text-center">{title}</p>
          <p className="text-[13px] font-inter text-[#808285] text-center">{description}</p>
        </div>

        <div
          className={
            "flex items-center justify-center gap-4 px-4 pt-2 pb-4 border-t border-dashed border-[#D8D8D9]"
          }
        >
          <Button size="xl" type="secondary" onClick={leftBtnAction || onClose} text={leftBtnText} disabled={disabled} />
           <Button
            type="primary"
            size="xl"
            icon={rightBtnIcon || ITidiedUp}
            text={rightBtnText}
            className="!bg-[#1B67DA] !text-white"
            onClick={onConfirm}
            disabled={disabled}
          />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalResult isOpen={isOpen} {...props} />;
};

export default Wrapper;
